import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { authSlice } from "./slices/auth.slice";
import { RootState } from "./root-state";
// import devToolsEnhancer from 'remote-redux-devtools'

const store = configureStore(
  {
    reducer: {
      auth: authSlice.reducer,
    },
    devTools: true
  }
);

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export default store;
